'use client';
import { AtHeader } from '@/components/atoms/at-header/at-header';
import { THeaderSupportedElements } from '@/components/atoms/at-header/at-header.types';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { TSpacing } from '@/lib/contentstack-sdk/types';
import classNames from 'classnames';
import { JSX } from 'react';

export interface ITmErrorProps {
  heading: string;
  heading_variant?: THeaderSupportedElements;
  body: string;
  topSpacing: TSpacing;
  bottomSpacing: TSpacing;
}

export const TmError = ({
  heading,
  heading_variant = 'h1',
  body,
  topSpacing = 'md',
  bottomSpacing = 'md',
}: ITmErrorProps): JSX.Element => {
  const topSpacingValues = {
    xs: 'pt-xs',
    sm: 'pt-sm',
    md: 'pt-md',
    lg: 'pt-lg',
    xl: 'pt-xl',
  };
  const bottomSpacingValues = {
    xs: 'pb-xs',
    sm: 'pb-sm',
    md: 'pb-md',
    lg: 'pb-lg',
    xl: 'pb-xl',
  };

  return (
    <div
      data-testid="tm-error"
      className={classNames(
        'm-auto w-full max-w-790 px-8 py-12 text-center md:px-0 md:py-180',
        topSpacingValues[topSpacing],
        bottomSpacingValues[bottomSpacing],
      )}
    >
      <AtHeader
        element="h1"
        variant={heading_variant}
        className="mb-6 text-skin-brand"
      >
        {heading}
      </AtHeader>
      <RenderRichText
        body={body}
        className="text-skin-tertiary [&_:not(h1,h2,h3,h4,h5,h6)]:text-base lg:[&_:not(h1,h2,h3,h4,h5,h6)]:text-xl [&_a]:font-normal [&_a]:text-skin-link [&_a]:underline"
      />
    </div>
  );
};
